import { Cliente } from "src/app/pages/clientes-mixtos/modelos/Cliente";
import { DocData } from "../table-doc/table-doc.component";

export class DocumentosMasClientes {
  documentos: DocData[];
  clientesHolding: Cliente[];
  formato: String;
}
